import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const translations = {
  ar: {
    // Welcome Screen
    welcomeTitle: 'مرحباً بك في لبيه ميسا',
    welcomeSubtitle: 'مساعدك الذكي للصحة النفسية',
    welcomeDescription: 'حياك الله..\n\nأنا مساعدك الافتراضي من وزارة الاستثمار، مهمتي الإجابة عن استفساراتك وتقديم الدعم اللازم.\n\nيرجى ملاحظة أن هذه الخدمة تعتمد على تقنيات الذكاء الاصطناعي.\n\nسيسعدنا دعمك في تقييم الإجابات لتساهم معنا في إثراء المحتوى وتطوير الخدمات.',
    startConversation: 'بدء المحادثة',
    switchToEnglish: 'English',
    
    // Chat Window
    newSession: 'بدء محادثة جديدة',
    closeChat: 'إغلاق المحادثة',
    sendMessage: 'إرسال',
    typePlaceholder: 'اكتب رسالتك هنا...',
    connecting: 'جاري الاتصال...',
    thinking: 'جاري التفكير...',
    speaking: 'جاري الرد...',
    livechat: 'الدردشة المباشرة',
    visitor: 'زائر',
    read: 'تم القراءة',
    selectOption: 'اختر أحد الخيارات...',
    
    // Error Messages
    connectionError: 'عذراً، فشل الاتصال بخدمة الدردشة. يرجى المحاولة مرة أخرى.',
    sendError: 'عذراً، فشل إرسال الرسالة. يرجى المحاولة مرة أخرى.',
  },
  en: {
    // Welcome Screen
    welcomeTitle: 'Welcome to Labeah MISA',
    welcomeSubtitle: 'Your Intelligent Mental Health Assistant',
    welcomeDescription: 'Welcome..\n\nI am your virtual assistant from the Ministry of Investment, my mission is to answer your inquiries and provide the necessary support.\n\nPlease note that this service relies on artificial intelligence technologies.\n\nWe would be pleased with your support in evaluating the responses to contribute with us in enriching the content and developing the services.',
    startConversation: 'Start Conversation',
    switchToArabic: 'العربية',
    
    // Chat Window
    newSession: 'Start New Conversation',
    closeChat: 'Close Chat',
    sendMessage: 'Send',
    typePlaceholder: 'Type your message here...',
    connecting: 'Connecting...',
    thinking: 'Thinking...',
    speaking: 'Responding...',
    livechat: 'Livechat',
    visitor: 'Visitor',
    read: 'Read',
    selectOption: 'Choose an option...',
    
    // Error Messages
    connectionError: 'Sorry, failed to connect to the chat service. Please try again.',
    sendError: 'Sorry, failed to send message. Please try again.',
  }
};

export const LanguageProvider = ({ children, isWidget = false }) => {
  // Default to Arabic
  const [language, setLanguage] = useState(() => {
    // Try to get saved language from localStorage
    try {
      const saved = localStorage.getItem('labeah_language');
      return saved || 'ar';
    } catch (error) {
      return 'ar';
    }
  });

  // Save language preference to localStorage and update document dir
  useEffect(() => {
    try {
      localStorage.setItem('labeah_language', language);
    } catch (error) {
      console.warn('Could not save language preference:', error);
    }

    // Update direction and lang attribute
    const direction = language === 'ar' ? 'rtl' : 'ltr';
    
    if (isWidget) {
      // For widget mode: DO NOT set dir on the container (it would affect positioning)
      // The ChatWindow component already sets dir={direction} on its root div
      // Just set the lang attribute for accessibility
      const widgetContainer = document.querySelector('.lmw-widget-container');
      if (widgetContainer) {
        widgetContainer.setAttribute('lang', language);
        console.log('🌐 Widget language set to:', language);
      }
    } else {
      // For standalone app: update the entire document
      document.documentElement.setAttribute('dir', direction);
      document.documentElement.setAttribute('lang', language);
      document.body.setAttribute('dir', direction);
      console.log('🌐 Document direction set to:', direction);
    }
  }, [language, isWidget]);

  const toggleLanguage = () => {
    setLanguage(prev => prev === 'ar' ? 'en' : 'ar');
  };

  const t = (key) => {
    return translations[language][key] || key;
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t,
    isRTL: language === 'ar',
    direction: language === 'ar' ? 'rtl' : 'ltr',
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

